import React from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import EditIcon from "@material-ui/icons/Edit";
import RestoreIcon from "@material-ui/icons/Restore";
import CommonLabelisationHead from "../../common/LabelisationHead";
import Icon from "./Icon";
import LabelerSegmentationStore from "../../../store/segmentation-store/labelerSegmentationStore";
import LabelerSegmentationUiStore from "../../../store/segmentation-store/labelerSegmentationUiStore";
import StickTwoPolygonsStore from "store/segmentation-store/stickTwoPolygonsStore";

const LabelisationHead = ({
  labelerSegmentationStore,
  labelerSegmentationUiStore,
  stickTwoPolygonsStore,
  history,
  match: {
    params: { noImage },
  },
}: any) => {
  const {
    images,
    batch,
    originalImages,
    restore,
    canNavigateToNextImage,
    canNvigateToPrevImage,
  } = labelerSegmentationStore as LabelerSegmentationStore;

  const {
    originalPolygons,
    hasModifications,
    setOpenAlertDialog,
    setAlertDialogText,
    setAlertDialogCallback,
    setResizeMode,
  } = labelerSegmentationUiStore as LabelerSegmentationUiStore;

  const { resetPolyStick } = stickTwoPolygonsStore as StickTwoPolygonsStore;

  const currentImageIndex = Number(noImage);
  const currentImage = images[currentImageIndex];

  const [pageInput, setPageInput] = React.useState<string>(
    String(currentImageIndex + 1)
  );

  React.useEffect(() => {
    setPageInput(String(currentImageIndex + 1));
  }, [currentImageIndex]);

  const canRestore =
    originalPolygons.length > 0 ||
    originalImages[currentImageIndex]?.motif !== null;

  const handleRestore = () => {
    setAlertDialogText("Êtes-vous sur de vouloir rétablir les labellisations ?");
    setAlertDialogCallback(restore);
    setOpenAlertDialog(true);
  };

  const navigateToIndex = (targetIndex: number) => {
    setResizeMode(false);
    resetPolyStick();
    history.push(`/labelerSegmentation/${batch.id}/${targetIndex}`);
  };

  const goToNextImage = () => {
    navigateToIndex(currentImageIndex + 1);
  };

  const goToPrevImage = () => {
    navigateToIndex(currentImageIndex - 1);
  };

  const handlePageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPageInput(event.target.value);
  };

  const navigateToPageInput = () => {
    const value = parseInt(pageInput, 10);
    if (isNaN(value)) {
      setPageInput(String(currentImageIndex + 1));
      return;
    }

    let targetIndex = value - 1;

    if (targetIndex < 0) {
      targetIndex = 0;
    }

    if (targetIndex >= images.length) {
      targetIndex = images.length - 1;
    }

    if (targetIndex !== currentImageIndex) {
      navigateToIndex(targetIndex);
    }
  };

  const headerActions = hasModifications ? (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        paddingRight: 8,
      }}
    >
      <EditIcon fontSize="small" style={{ color: "orange" }} />
      <Typography
        style={{
          color: "orange",
          marginLeft: 2,
          marginRight: canRestore ? 4 : 0,
        }}
      >
        modifiée
      </Typography>
      {canRestore && (
        <Icon
          title="Rétablir les labelisations"
          disabled={false}
          component={RestoreIcon}
          onClick={handleRestore}
        />
      )}
    </div>
  ) : null;

  return (
    <CommonLabelisationHead
      itemLabel="Image"
      prevTitle="Image précédente"
      nextTitle="Image suivante"
      currentIndex={currentImageIndex}
      total={images.length}
      nomBatch={batch.name}
      lastLabeledBy={currentImage?.lastLabeledBy}
      isLabeled={
        (currentImage?.labels?.polygonLabels?.length || 0) > 0 ||
        !!currentImage?.motif
      }
      currentIndexNode={
        <input
          value={pageInput}
          onChange={handlePageChange}
          onBlur={navigateToPageInput}
          onKeyPress={(event: React.KeyboardEvent<HTMLInputElement>) => {
            if (event.key === "Enter") {
              navigateToPageInput();
            }
          }}
          style={{
            textAlign: "center",
            padding: "0 4px",
            width: 32,
            height: 20,
            fontSize: "0.8rem",
            marginLeft: 8,
            marginRight: 4,
            borderRadius: 4,
            border: "1px solid #ccc",
          }}
        />
      }
      headerActions={headerActions}
      onPrevious={goToPrevImage}
      onNext={goToNextImage}
      prevDisabled={!canNvigateToPrevImage()}
      nextDisabled={!canNavigateToNextImage()}
    />
  );
};

export default withRouter(
  inject(
    "labelerSegmentationUiStore",
    "labelerSegmentationStore",
    "stickTwoPolygonsStore"
  )(observer(LabelisationHead))
);
